/* eslint-disable react-hooks/exhaustive-deps */
import React, { PropsWithChildren, useCallback, useEffect, useMemo, useRef, useState } from "react";
import moment from "moment";
import ActivityItem from "../../../components/activityItem";
import LeadNoteItems from "../../../components/leadNoteItems";
import LeadStatus from "../../../components/leadStatus";
import EmptyState from "../EmptyState";
import {
  assignLeadInList,
  copyLeadInList,
  deleteBulkLeads,
  getLeadDetail,
  moveLeadInList,
  sendLeadToMobile,
  shareContentLead,
  updateLead,
  updateLeadProducts,
} from "../../../services/leadService";
import ContactLinksGenerator from "../../../utils/contactlinksgenerator";
import _ from "lodash";
import LeadLabel from "../../../components/leadLabel";
import DrawerComponent from "../../../components/drawer";
import FileUpload from "../FileUpload";
import { useSelector, useDispatch } from "react-redux";
import toast from "react-hot-toast";
import {
  setActivityList,
  setNote,
  setLeadTaskList,
  leadFileList,
  updateSingleLead,
} from "../../../actions/actions";

import {
  getLeadFormResponse,
} from "../../../services/formService";
import FormResponse from "../../userForm/FormResponse";
import TaskDrawer from "../../common/TaskDrawer";

import { deleteTask, taskById } from "../../../services/taskService";

import CreateActivityForm from "../../../components/createActivityForm";
import { activityById, createActivity } from "../../../services/activityService";
import ConfirmationModal from "../../../components/confirmationModal";
import CreateNoteForm from "../../../components/createNoteForm";
import GlobalDrawer from "../../../components/GlobalDrawer";
import { getAllLeadList } from "../../../services/leadListService";
import {
  FaExternalLinkAlt,
  FaPhone,
  FaPhoneAlt,
  FaWhatsapp,
} from "react-icons/fa";
import {
  MdEdit,
  MdOutlineAttachFile,
  MdOutlineMail,
  MdSave,
} from "react-icons/md";
import { addCountryCode, convertToIST } from "../../../utils/helpers";

import { getAllContent } from "../../../services/contentService";
import { IoIosArrowDown } from "react-icons/io";

import CreateLeadForm from "../createLeadForm";
import Information from "./Information";
import NewTaskItem from "../../../components/newTaskItem";
import { MdOutlineEdit } from "react-icons/md";
import LeadOptionsMenu from "./LeadOptionsMenu";
import LeadActionIcons from "./LeadActionIcons";
import { Edit, Pencil, ShoppingCart } from "lucide-react";
import ActivityTab from "../activitytab/ActivityTab";
import TaskForm from "../../../components/TaskForm";
import { sendLeadToAllDevices } from "../../../services/leadService";
import logger, { Logger } from '../../../utils/logger';
import ProductPickerPopup from "../../../components/ProductPickerPopup";
import AssignLeadDrawer from "../../../components/AssignLeadDrawer";
import LeadInfoPanel from "./LeadInfoPanel";
import BulkShareModal from "../../../components/BulkLeadOptions/BulkShareModal";
// TODO: WhatsApp Conversations Feature - Import commented out for release
// import LeadCommunicationPopup from "./LeadCommunicationPopup";



const MemoizedProductPickerPopup = React.memo(ProductPickerPopup);


interface LeadDataI {
  _id: string;
  leadListId?: string;
  name: string;
  integration: string;
  customSource: string;
  createdAt: Date;
  status: Array<string>;
  saleValue: string;
  website: string;
  label: Array<any>;
  deleteLeadFromDrawer: (id: string) => void;
  copyLeadToList: () => void;
  moveLeadToList: () => void;
  onLabelClick: () => void;
  onStatusClick: () => void;
  setFrom: React.Dispatch<React.SetStateAction<string>>;
  handleEditModal: (name: string, id: any, action: string) => void;
  handleLeadDetailsModalOpen: (title: string, name: string) => void;
  onLeadFileUpload: (e: any) => void;
  editLead: (e: any, id: string) => void;
  leadFileDelete: (obj: any) => void;
  refreshData?: () => void;
  onDeleteLead?: () => void;
}

interface ProductWithQuantity {
  _id: string;
  name: string;
  price: number;
  quantity: number;
  // Add other fields as needed
}

interface SelectedLeadI {
  activities: Array<any>;
  label: Array<any>;
  notes: Array<{
    createdAt: Date;
    createdBy: Date;
    description: string;
    lead: string;
    _id: string;
  }>;
  tasks: Array<any>;
  phone: string;
  email: string;
}


const LeadDetails: React.FC<PropsWithChildren<LeadDataI>> = ({
  _id,
  leadListId,
  name,
  integration,
  customSource,
  createdAt,
  status,
  saleValue,
  website,
  label,
  deleteLeadFromDrawer,
  copyLeadToList,
  moveLeadToList,
  onLabelClick,
  onStatusClick,
  setFrom,
  handleEditModal,
  handleLeadDetailsModalOpen,
  onLeadFileUpload,
  editLead,
  leadFileDelete,
  refreshData,
  onDeleteLead,
}) => {
  const StoreData = useSelector((state: any) => {
    return state?.rootReducers;
  });
  const [selectedLeadData, setSelectedLeadData] = useState<SelectedLeadI>({
    activities: [],
    label: [],
    notes: [],
    tasks: [],
    phone: "",
    email: "",
  });
  const createLeadFormRef = useRef();
  const [disableLeadInfo, setDisableLeadInfo] = useState<boolean>(true);
  const [leadData, setLeadData] = useState<any>({});
  
  const [showConfirmationModal, setShowConfirmationModal] =
    useState<boolean>(false);
  
    const [isProductPickerOpen, setIsProductPickerOpen] = useState(false);
    const [selectedProducts, setSelectedProducts] = useState<ProductWithQuantity[]>([]);

const [isLoadingLists, setIsLoadingLists] = useState(false);


const [showBulkShareModal, setShowBulkShareModal] = useState(false);
// TODO: WhatsApp Conversations Feature - State commented out for release
// const [showWhatsAppPopup, setShowWhatsAppPopup] = useState(false);

 const renderCount = useRef(0);
  const prevIdRef = useRef(_id);
  const startTime = useRef(Date.now());
  const [viewFormResponse, setViewFormResponse] = useState<boolean>(false);
  const [openWithHeader, setOpenWithHeader] = useState<boolean>(false);
  const [openFileDrawer, setOpenFileDrawer] = useState<any>(false);
  const [copyLeadDrawer, setCopyLeadDrawer] = useState(false);
  const [shareLeadDrawer, setShareLeadDrawer] = useState(false);
  const [assignLeadDrawer, setAssignLeadDrawer] = useState(false);



    useEffect(() => {
    renderCount.current += 1;
    const currentTime = Date.now();
    const timeSinceStart = currentTime - startTime.current;
    const prevId = prevIdRef.current;
    const currentId = _id;

    logger.log('⏰ Time since component start:', timeSinceStart + 'ms');
    logger.log('🆔 ID Change:', {
      previous: prevId,
      current: currentId,
      changed: prevId !== currentId
    });
    logger.log('📊 Component State:', {
      hasLeadData: !!leadData,
      leadDataId: leadData?._id,
      contentDataLength: contentData?.length || 0
    });
    logger.log('🎯 Props received:', {
      _id: _id,
      name: name,
      hasAllProps: !!(_id && name)
    });
    
    // Track if this will trigger fetchLeadDetails
    if (prevId !== currentId && currentId) {
      logger.log('🚨 ID CHANGED - This will trigger fetchLeadDetails API call!');
      logger.log('📞 Expected API call for lead ID:', currentId);
    }
    
    // Update the ref for next comparison
    prevIdRef.current = currentId;
    
    
    
    // Log to track component lifecycle
    return () => {
      if (renderCount.current === 1) {
        logger.log('🔄 LeadDetails component unmounting after', renderCount.current, 'renders');
      }
    };
  });
  
  useEffect(() => {
    renderCount.current += 1;
    
    // Log details about the current render
    logger.log('LeadDetails Render Count:', renderCount.current, {
      isProductPickerOpen,
      selectedProductsLength: selectedProducts.length,
      selectedProductsRef: Object.prototype.toString.call(selectedProducts),
      // Log other props or state that might cause re-renders
    });
    
    // Monitor the products state specifically
    logger.log('Selected Products on render:', JSON.stringify(selectedProducts.map(p => p._id)));
  }, [isProductPickerOpen, selectedProducts]);


  const contactGenerator = useMemo(() => {
    // Create a contact generator using data from leadData or selectedLeadData
    const phone = leadData?.phone || selectedLeadData?.phone || "";
    const email = leadData?.email || selectedLeadData?.email || "";
    
    return new ContactLinksGenerator({
      number: phone,
      email: email,
      message: "Hello"
    });
  }, [leadData?.phone, leadData?.email, selectedLeadData?.phone, selectedLeadData?.email]);


  const [action, setAction] = useState<string>("");
  const [taskData, setTaskData] = useState<any>({});
  const [formData, setFormData] = useState({});
  const [activityData, setActivityData] = useState<any>({});
  const dispatch = useDispatch();
  const StateData = useSelector((state: any) => {
    return state?.rootReducers;
  });
  
  const [activeLeadOption, setActiveLeadOption] = useState("copy");
  const [leadOwnerName, setLeadOwnerName] = useState<any>("");
  const [extraDetails, setExtraDetails] = useState<any>({});

  const [leadListData, setLeadListData] = useState<any>([]);

  const [activeLeadId, setActiveLeadId] = useState("");

const [isLoadingContent, setIsLoadingContent] = useState(false);
const [contentData, setContentData] = useState<any[]>([]);

  const [contentType, setContentType] = useState("message");
  const [deleteModal, setDeleteModal] = useState<boolean>(false);

  const handleSafeClose = () => {
    // React will batch these updates automatically
    setOpenWithHeader(false);
    setAction("");
    setTaskData({});
    setActivityData({});
    
    // Only call refreshData if it exists
    if (refreshData) {
      refreshData();
    }
  };
  



 // Current code:
const teamMembers = useMemo(() => 
  StateData?.userData?.userDetails?.organizationEmployee
    ?.filter((item: any) => 
      item?._id !== StateData?.userData?.userDetails?._id && 
      item?.isActive === true
    )
    .map((item: any) => ({
      value: item?._id, 
      label: `${item?.firstName} ${item?.lastName}`,
      role: item?.role
    })), 
  [StateData?.userData?.userDetails]
);

 
const handleClosePicker = useCallback(() => {
  setIsProductPickerOpen(false);
}, []);


// Update the fetchLeadDetails function to properly handle product data
const fetchLeadDetails = useCallback(async () => {
  try {
    const response = await getLeadDetail(_id);
    if (response && response.status) {
      let responseData = response?.data?.data;

      
      let leadOwnerName =
        StateData?.userData?.userDetails?.organizationEmployee?.find(
          (x: any) => x._id == responseData.createdBy
        );
      let first_name = leadOwnerName?.firstName;
      let last_name = leadOwnerName?.lastName ? leadOwnerName?.lastName : "";
     setLeadData(responseData);
      logger.log('💾 LeadDetails - Data set, passing to Information:', !!responseData);
      dispatch(setActivityList(responseData?.activities));
      dispatch(setLeadTaskList(responseData?.tasks));
      dispatch(setNote(responseData?.notes));
      dispatch(leadFileList(responseData?.files));
      setExtraDetails(responseData.extraDetails || {});
      setLeadOwnerName(first_name + " " + last_name);
      setSelectedLeadData({
        ...selectedLeadData,
        activities: responseData?.activities,
        label: responseData?.label,
        notes: responseData?.notes,
        tasks: responseData?.tasks,
        phone: responseData?.phone,
        email: responseData?.email,
      });
      
      // Set selected products from lead data if available
      if (responseData.products && responseData.products.length > 0) {
        logger.log('Setting selected products from lead data:', responseData.products);
        // Transform the products to match the ProductWithQuantity interface
        const productsWithQuantity = responseData.products.map((product: any) => {
          logger.log('Processing product in transformatoin:', {
            product,
            hasId: !!product.id,
            hasUnderscore: !!product._id
          });
          
          const productId = product.id || product._id;
          logger.log('Extracted product ID:', productId);
          
          const transformed = {
            _id: productId,
            name: product.name,
            price: parseFloat(product.price) || 0,
            quantity: parseFloat(product.quantity) || 1
          };
          
          logger.log('Transformed product:', transformed);
          return transformed;
        });
        setSelectedProducts(productsWithQuantity);
      } else {
        // Reset selected products if none in the lead data
        setSelectedProducts([]);
      }
    }
  } catch (err) {
    Logger.log(err);
    console.error('Error fetching lead details:', err);
  }
}, [_id, StateData?.userData?.userDetails?.organizationEmployee, dispatch, selectedLeadData]);

  useEffect(() => {
    fetchLeadDetails();
  }, [_id]);
  

const handleQuickShare = useCallback(async () => {
  logger.log('🚀 Quick Share clicked - fetching content data...');
  
  try {
    setIsLoadingContent(true);
    
    // Fetch content data when user clicks quick share
    const response = await getAllContent({
      isAscending: false,
      page: 1,
      perPage: 500,
    });
    
    logger.log('📡 Content API Response:', response);
    
    if (response?.status) {
      logger.log('✅ Content loaded:', response.data.data.length, 'templates');
      setContentData(response.data.data);
      setShowBulkShareModal(true); // Open modal after data is loaded
    } else {
      console.error('❌ Failed to load content');
      alert('Failed to load content templates');
    }
  } catch (error) {
    console.error('❌ Error fetching content:', error);
    alert('Error loading content templates');
  } finally {
    setIsLoadingContent(false);
  }
}, []);

  const getAllCustomFormResponse = async () => {
    try {
      const response = await getLeadFormResponse(_id);
      const formResponse = response.data.data[0];

      if (formResponse) {
        setFormData(formResponse);
        setViewFormResponse(true);
      } else {
        toast.error("Form response not found");
      }
    } catch (error) {
      console.error("Error fetching form response:", error);
      toast.error("Failed to load form response");
    }
  };

  const handleDelete = () => {
    if (action === "editTask") {
      onConfirmation(taskData?._id || "", "task");
    }
    if (action === "editActivity") {
      onConfirmation(activityData?._id || "", "activity");
    }
  };


 // In LeadDetails.tsx, update the handleProductsSelect function:
const handleProductsSelect = useCallback((products: ProductWithQuantity[]) => {
  logger.log('Products selected:', products);
  

// Calculate total value from products - use manual override if provided  
const calculatedTotal = (products as any).manualSaleValue || products.reduce((sum, p) => sum + (p.price * p.quantity), 0);
  
  // Format products array for API
  const productsForApi = products.map(p => ({
    id: p._id,
    quantity: p.quantity
  }));
  
  // Show loading toast
  const loadingToast = toast.loading("Updating lead...");
  
  // Update lead with selected products AND sale value
  updateLeadProducts(_id, productsForApi, calculatedTotal)
    .then(response => {
      toast.dismiss(loadingToast);
      toast.success("Products updated successfully");
      
      if (response?.data?.data) {
        const updatedLead = response.data.data;
        setLeadData(updatedLead);
      }
    })
    .catch(error => {
      toast.dismiss(loadingToast);
      toast.error("Failed to update products");
    })
    .finally(() => {
      // Close the product picker
      handleClosePicker();
    });
}, [_id, handleClosePicker]);
  
  const handleEditActivityModal = async (
    name: string,
    _id: any,
    action: string
  ) => {
    if (name === "activity") {
      try {
        const response = await activityById(_id);
        if (response && response.status) {
          setActivityData(response.data.data);
          setAction("editActivity");
          setOpenWithHeader(true);
        }
      } catch (err) {
        toast.error("error while fetching activity data.");
      }
    }
    if (name === "task") {
      try {
        const response = await taskById(_id);
        if (response && response.status) {
          setTaskData(response.data.data);
          setAction("editTask");
          setOpenWithHeader(true);
        }
      } catch (err) {
        toast.error("error while fetching activity data.");
      }
    }
  };

  
  const toggleConfirmationModal = () => {
    setShowConfirmationModal(!showConfirmationModal);
  };

  const handleCopyToList = useCallback(async () => {
  logger.log('📋 Copy to List clicked - fetching list data...');
  
  try {
    setIsLoadingLists(true);
    setActiveLeadOption("copy"); // Set the action type
    
    // Fetch lead lists when user clicks copy
    const response = await getAllLeadList({
      isAscending: false,
      page: 1,
      perPage: 100,
    });
    
    logger.log('📡 Lead Lists API Response:', response);
    
    if (response?.status) {
      logger.log('✅ Lead lists loaded:', response.data.data.length, 'lists');
      setLeadListData(response.data.data);
      setCopyLeadDrawer(true); // Open drawer after data is loaded
    } else {
      console.error('❌ Failed to load lead lists');
      alert('Failed to load lead lists');
    }
  } catch (error) {
    console.error('❌ Error fetching lead lists:', error);
    alert('Error loading lead lists');
  } finally {
    setIsLoadingLists(false);
  }
}, []);

const handleMoveToList = useCallback(async () => {
  logger.log('📋 Move to List clicked - fetching list data...');
  
  try {
    setIsLoadingLists(true);
    setActiveLeadOption("move"); // Set the action type
    
    // Same API call as copy, but different action
    const response = await getAllLeadList({
      isAscending: false,
      page: 1,
      perPage: 100,
    });
    
    if (response?.status) {
      logger.log('✅ Lead lists loaded for move:', response.data.data.length, 'lists');
      setLeadListData(response.data.data);
      setCopyLeadDrawer(true); // Same drawer, different action
    } else {
      alert('Failed to load lead lists');
    }
  } catch (error) {
    console.error('❌ Error fetching lead lists:', error);
    alert('Error loading lead lists');
  } finally {
    setIsLoadingLists(false);
  }
}, []);

  const onConfirmation = async (id: string, name: string) => {
    if (name === "task" && id) {
      try {
        const response = await deleteTask(id);
        if (response && response.status) {
          toast.success(response?.data?.message);
          const tempArray = [...StateData?.leadTask?.leadTask];

          const tempData = tempArray.findIndex((x) => x._id == taskData._id);
          tempArray.splice(tempData, 1);
          dispatch(setLeadTaskList(tempArray));

          setTaskData({});
          toggleConfirmationModal();
        }
      } catch (err) {
        toast.error("Error while deleting task!");
      }
      setOpenWithHeader(false);
      setAction("");
    }
    if (name === "activity" && id) {
      // try {
      //   const response = await deleteTask(id);
      //   if (response && response.status) {
      //     toast.success(response?.data?.message);
      //     handleTaskFollowup(response?.data?.data);
      //     setTaskData({});
      //   }
      // } catch (err) {
      //   toast.error("Error while deleting task!");
      // }
      setOpenWithHeader(false);
      setAction("");
    }
  };

  
  const handleTaskFollowup = useCallback((responseData?: any) => {
    if (responseData) {
      const tempArray = [...StateData?.leadTask?.leadTask];
      if (action === "addTask") {
        tempArray?.unshift(responseData?.data);
        setLeadData(responseData?.lead);
      } else {
        const tempData = tempArray.findIndex((x) => x._id == responseData.data._id);
        tempArray.splice(tempData, 1, responseData.data);
      }
      dispatch(setLeadTaskList(tempArray));
    }
  }, [action, StateData?.leadTask?.leadTask, dispatch]);

  const handleCopyLead = async (leadId: string) => {
    try {
      const data = {
        leadIDs: [leadData._id],
        targetListId: leadId === "" ? null : leadId, // Handle default list case
      };

      if (activeLeadOption == "copy") {
        const response = await copyLeadInList(data);
        toast.success(response?.data?.message);
      } else {
        const response = await moveLeadInList(data);
        toast.success(response?.data?.message);
      }
      setCopyLeadDrawer(false);
    } catch (err) {
      Logger.log();
    }
  };

  const handleAssignLead = async (leadId: string) => {
    try {
      const data = {
        leadIds: [leadData._id],
        assignToUser: leadId,
      };
      const response = await assignLeadInList(data);
      toast.success(response?.data?.message);
      setAssignLeadDrawer(false);
    } catch (err) {}
  };

 

const drawerTitle =
  action === "addTask"
    ? "Add Task"
    : action === "editTask"
    ? "Edit Task"
    : action === "addActivity"
    ? "Add Activity"
    : action === "addNotes"        // ← ADD THIS LINE
    ? "Add Notes"                  // ← ADD THIS LINE
    : action === "editActivity"
    ? "Edit Activity"
    : "Edit Activity";

  // const onScrollLeadMore = () => {
  //   // 20 more records in .5 secs
  //   // setTimeout(() => {
  //   //   setActivityData(StateData.concat(Array.from({ length: 3 })));
  //   // }, 500);
  // };
  // phoneNumber.substring(phoneNumber.length - 10)

const validateNumber = (number: string): string => {
  // Use ContactLinksGenerator's smart logic
  const contactObj = new ContactLinksGenerator({
    number: number,
    email: "",
    message: ""
  });
  
  // Extract the formatted number (remove + for WhatsApp URL)
  return contactObj._number.replace(/^\+/, '');
};

  //  Share lead
  const shareContent = async (data: any, share: string) => {
    if (data.type == "file" || data.type == "page") {
      try {
        const body = {
          contentId: data._id,
          leadIds: [_id],
          performedAt: createdAt,
          contentType: data.type,
        };
        const response = await shareContentLead(body);
        const message = `Hi ${name || ""},

          Here's the link to view new one:
          ${response.data.data.uniqueLink}`;
        if (share == "whatsapp") {
          const whatsappUrl = `https://api.whatsapp.com/send?phone=${encodeURIComponent(
            validateNumber(contactGenerator?._number || "")
          )}&text=${encodeURIComponent(message)}`;
          window.open(whatsappUrl, "_blank");
        } else {
          const subject = `Hi ${name || ""}, ${
            StateData?.userData?.userDetails?.firstName
          } ${StateData?.userData?.userDetails?.lastName} has shared ${
            data.type
          } with you`;
          const emailUrl = `mailto:${
            contactGenerator?.mail
          }?subject=${subject}&body=${encodeURIComponent(message)}`;
          window.open(emailUrl, "_blank");
        }
      } catch (err) {
        Logger.log();
      }
    } else {
      try {
        const body = {
          type: "share",
          // contentId: data._id,
          leadIds: [_id],
          performedAt: createdAt,
          // contentType: data.type
        };

        const response = await createActivity(body);
        Logger.log("response ======>", response.data.data.uniqueLink);

        const message = (
          data.details?.description || data.details?.message
        )?.replace(/@lead name/g, name || "");
        if (share == "whatsapp") {
          const whatsappUrl = `https://api.whatsapp.com/send?phone=${encodeURIComponent(
            validateNumber(contactGenerator?._number || "")
          )}&text=${encodeURIComponent(message)}`;
          window.open(whatsappUrl, "_blank");
        } else {
          const subject = `Hi ${name || ""}, ${
            StateData?.userData?.userDetails?.firstName
          } ${StateData?.userData?.userDetails?.lastName} has shared ${
            data.type
          } with you`;
          const emailUrl = `mailto:${
            contactGenerator?.mail
          }?subject=${subject}&body=${encodeURIComponent(message)}`;
          window.open(emailUrl, "_blank");
        }
      } catch (err) {
        Logger.log();
      }
    }
  };

  const handleDeleteLead = async () => {
    try {
      const response = await deleteBulkLeads({
        leadIDs: [_id],
      });
      if (response && response.status) {
        toast.success(response?.data?.message);
        onDeleteLead && onDeleteLead();
      }
    } catch (err) {
      Logger.log(err, "Error");
    }
  };

 /**
 * Send the current lead to all mobile devices
 */
const handleSendToMobile = async () => {
  try {
    // Use the enhanced function to send to all devices
    const response = await sendLeadToAllDevices(_id, name);
    
    if (response && response.status) {
      toast.success("Lead sent to all mobile devices");
    }
  } catch (err) {
    console.error("Error sending lead to mobile:", err);
    toast.error("Failed to send lead to mobile devices");
  }
};
  



  // Add this memoized total calculation before the return statement:
const productTotal = useMemo(() => 
  selectedProducts.reduce((sum, p) => sum + (p.price * p.quantity), 0), 
  [selectedProducts]
);

  const getEmployeeInfoById = useCallback((id: string) => {
    const info = StateData?.userData?.userDetails?.organizationEmployee?.find(
      (e: any) => e._id === id
    );
    return `${info?.firstName ?? "-"}  ${info?.lastName ?? ""}` || "-";
  }, [StateData?.userData?.userDetails]);
  
  const getListInfoById = useCallback((id: string) => {
    const info = StateData?.userData?.userDetails?.organizationLeadList?.find(
      (e: any) => e._id === id
    );
    return info?.name || "-";
  }, [StateData?.userData?.userDetails]);

  const isDeleteable = useMemo(() => 
    StateData?.userData?.userDetails?.userPreference?.screenPermission?.includes(
      "lead_profile_screen > options_modal > delete"
    ),
    [StateData?.userData?.userDetails]
  );
    return (
      <div className="row" style={{ height: "100%" }}>
        <div className="col-md-4" style={{ paddingRight: "0" }}>
          <div className="popup-section-4-left" style={{ padding: "0px", height: "100%" }}>
          <LeadOptionsMenu 
  leadId={_id}
   onCopyToList={isLoadingContent ? () => {} : () => { handleCopyToList(); }}
  onMoveToList={isLoadingContent ? () => {} : () => { handleMoveToList(); }}
  onAssignLead={() => {
    setAssignLeadDrawer(true);
  }}
 

onShare={isLoadingContent ? () => {} : () => { handleQuickShare(); }}


  onSendToMobile={handleSendToMobile}
  onDelete={isDeleteable ? () => setDeleteModal(true) : undefined}
  isDeleteAllowed={isDeleteable}
/>
        

          <div style={{ padding: "10px" }}>
            <div className="d-flex justify-content-center flex-column align-items-center">
              <h3
                className="text-capitalize text-black"
                style={{
                  fontSize: "16px",
                  fontWeight: "700",
                  fontFamily: "Gilroy-Bold",
                }}
              >
                {name || "No Name"}
              </h3>

              <div className="d-flex align-items-center mt-2 mb-2">
           
              <button 
  className="btn btn-outline-primary d-flex align-items-center" 
  onClick={() => setIsProductPickerOpen(true)}
>
  <ShoppingCart size={16} className="me-2" />
  {selectedProducts.length > 0 ? (
    <span>
      ₹ {(productTotal > 0 ? productTotal : Number(leadData?.saleValue || 0)).toLocaleString()} 
      <span className="ms-1 badge bg-primary rounded-pill">
        {selectedProducts.length} {selectedProducts.length === 1 ? 'product' : 'products'}
      </span>
    </span>
  ) : (
    leadData?.saleValue ? `₹ ${Number(leadData.saleValue).toLocaleString()} - Add Products` : 'Add Products'
  )}
</button>
</div>
              {/* <div className="dropdown">
                            <button className="btn btn-sm btn-secondary ms-2 pt-1 pb-0 pe-2 ps-2 mt-1 dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                            </button>
                            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                <li><p className="dropdown-item">Assign Lead</p></li>
                                <li><p className="dropdown-item" onClick={() => copyLeadToList()}>Copy Lead to List</p></li>
                                <li><p className="dropdown-item" onClick={() => moveLeadToList()}>Move Lead to List</p></li>
                                <li><p className="dropdown-item" onClick={() => deleteLeadFromDrawer(_id)}>Delete Lead</p></li>
                            </ul>
                        </div> */}
            </div>
            <LeadActionIcons
  phone={leadData?.phone}
  email={leadData?.email}
  onFileClick={() => setOpenFileDrawer(true)}
  onEditClick={(e) => editLead(e, _id)}
  onFormResponseClick={() => getAllCustomFormResponse()}
  contactLinksGenerator={contactGenerator}
  hasCustomForms={leadData?.customForms?.length > 0}
  leadId={_id}
  leadName={name}
  // TODO: WhatsApp Conversations Feature - Prop commented out for release
  // onWhatsAppClick={() => setShowWhatsAppPopup(true)}
/>

<DrawerComponent
  openWithHeader={openFileDrawer}
  setOpenWithHeader={() => setOpenFileDrawer(false)} // Direct setter function
  drawerTitle={`Files ${StateData?.leadFile?.leadFile?.length}`}
  size="sm"
>
  <FileUpload
    onLeadFileUpload={onLeadFileUpload}
    StateData={StateData}
    leadFileDelete={leadFileDelete}
    leadId={_id}
  />
</DrawerComponent>


        <LeadInfoPanel
  lead={{
    name: name || "No Name",
    email: selectedLeadData?.email || leadData?.email || "",
    phone: selectedLeadData?.phone || leadData?.phone || "",
    status: status || [],
    labels: label?.map((l: any) => ({ 
      value: typeof l === 'string' ? l : l.value || l, 
      color: typeof l === 'object' ? l.color : undefined 
    })) || [],
    createdAt: createdAt,
    leadSource: customSource !== "" 
      ? _.capitalize(customSource?.split("_")?.join(" "))
      : _.capitalize(integration || ""),
    createdBy: getEmployeeInfoById(leadData?.createdBy),
    assignedTo: getEmployeeInfoById(leadData?.assignedTo),
    list: leadData?.list ? getListInfoById(leadData?.list) : "",
    saleValue: leadData?.saleValue || saleValue
  }}
  onStatusEdit={() => {
    onStatusClick();
    setFrom("details");
  }}
  onLabelEdit={() => {
    onLabelClick();
    setFrom("details");
  }}
  // Removed all action-related props since LeadActionIcons handles them
/>
          </div>
        </div>
      </div>
      <div className="col-md-8">
        <div
          className="popup-section-4-right"
          style={{ padding: "14px 25px", height: "100%" }}
        >
          <ul
            className="nav nav-pills d-flex gap-2"
            id="pills-tab"
            role="tablist"
          >
            <li className="nav-item flex-fill" role="presentation">
              <button
                className="nav-link active"
                id="pills-activites-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-activites"
                type="button"
                role="tab"
                aria-controls="pills-activites"
                aria-selected="true"
              >
                Activities ({leadData?.totalActivities || 0})
              </button>
            </li>
            <li className="nav-item flex-fill" role="presentation">
              <button
                className="nav-link"
                id="pills-task-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-task"
                type="button"
                role="tab"
                aria-controls="pills-task"
                aria-selected="false"
              >
                Tasks ({leadData?.totalTasks || 0})
              </button>
            </li>
            <li className="nav-item flex-fill" role="presentation">
              <button
                className="nav-link"
                id="pills-notes-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-notes"
                type="button"
                role="tab"
                aria-controls="pills-notes"
                aria-selected="false"
              >
                Notes ({leadData?.totalNotes || leadData?.totalNote || 0})
              </button>
            </li>
            <li className="nav-item flex-fill" role="presentation">
              <button
                className="nav-link"
                id="pills-Info-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-Info"
                type="button"
                role="tab"
                aria-controls="pills-Info"
                aria-selected="false"
              >
                Info
              </button>
            </li>
          </ul>
          <div className="tab-content pt-2" id="myTabContent">
          <div
  className="tab-pane fade show active"
  id="pills-activites"
  role="tabpanel"
  aria-labelledby="activites-tab"
>
  <ActivityTab
    leadId={_id}
    totalActivities={leadData?.totalActivities || 0}
    onAddActivity={() => {
      setAction("addActivity");
      setOpenWithHeader(true);
    }}
    onEditActivity={(activityId, action) => {
      handleEditActivityModal('activity', activityId, action);
    }}
  />
</div>
            <div
              className="tab-pane fade"
              id="pills-task"
              role="tabpanel"
              aria-labelledby="task-tab"
            >
              <div className="row popup-section-4-add-11">
                <button
                  className="btn align-items-center"
                  onClick={() => {
                    setAction("addTask");
                    setOpenWithHeader(true);
                  }}
                >
                  <svg
                    width="19"
                    height="18"
                    viewBox="0 0 19 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.5 16.2C5.3105 16.2 1.9 12.969 1.9 9C1.9 5.031 5.3105 1.8 9.5 1.8C13.6895 1.8 17.1 5.031 17.1 9C17.1 12.969 13.6895 16.2 9.5 16.2ZM9.5 0C8.25244 0 7.0171 0.232792 5.86451 0.685084C4.71191 1.13738 3.66464 1.80031 2.78249 2.63604C1.00089 4.32387 0 6.61305 0 9C0 11.3869 1.00089 13.6761 2.78249 15.364C3.66464 16.1997 4.71191 16.8626 5.86451 17.3149C7.0171 17.7672 8.25244 18 9.5 18C12.0196 18 14.4359 17.0518 16.2175 15.364C17.9991 13.6761 19 11.3869 19 9C19 7.8181 18.7543 6.64778 18.2769 5.55585C17.7994 4.46392 17.0997 3.47177 16.2175 2.63604C15.3354 1.80031 14.2881 1.13738 13.1355 0.685084C11.9829 0.232792 10.7476 0 9.5 0ZM10.45 4.5H8.55V8.1H4.75V9.9H8.55V13.5H10.45V9.9H14.25V8.1H10.45V4.5Z"
                      fill="white"
                    />
                  </svg>
                  Add Task
                </button>
              </div>
              <TaskDrawer
  openWithHeader={openWithHeader}
  setOpenWithHeader={setOpenWithHeader}
  onTaskDelete={toggleConfirmationModal}
  showDelete={action.includes("edit")}
  drawerTitle={drawerTitle}
  size="xs"
>
             {(action === "addTask" || action === "editTask") && (
  <TaskForm
    leadId={_id} // This is now required
    updateTaskValue={taskData}
    action={action === "addTask" ? "add" : "edit"}
    status={""}
    
    drawerClose={() => {
      setOpenWithHeader(false);
      setAction("");
    }}
    fetchTaskStatusFollowUps={handleTaskFollowup}
  />
)}

                {(action === "addActivity" || action === "editActivity") && (
                  <CreateActivityForm
                    leadIds={[{ id: _id }]}
                    updateModalValue={activityData}
                    action={action === "addActivity" ? "Add" : "Edit"}
                    formName={"Activity"}
                    handleActivityFormSubmit={(data) => {
                      setOpenWithHeader(false);
                      setAction("");
                      if (data) {
                        setLeadData(data);
                      }
                    }}
                  />
                )}
                {(action === "addNotes" || action === "editNotes") && (
                  <CreateNoteForm
                    leadIds={[{ id: _id }]}
                    handleNotesSubmit={(data) => {
                      setOpenWithHeader(false);
                      setAction("");

                      if (data) {
                        setLeadData(data);
                      }
                    }}
                  />
                )}
              </TaskDrawer>
              <div
                className={
                  StateData?.leadTask?.leadTask?.length > 3
                    ? "row activity-scroll"
                    : "row"
                }
              >
                {StateData?.leadTask?.leadTask?.length > 0 ? (
                  StateData?.leadTask?.leadTask?.map((task: any, i: number) => (
                    <NewTaskItem
                      activity={task}
                      onEditTask={(info) => {
                        setAction("editTask");
                        setTaskData(info);
                        setOpenWithHeader(true);
                      }}
                    />
                  ))
                ) : (
                  <EmptyState type="tasks" />
                )}
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="pills-notes"
              role="tabpanel"
              aria-labelledby="notes-tab"
            >
              <div className="row popup-section-4-add-11">
                <button
                  className="btn align-items-center"
                
                  onClick={() => {
                    setAction("addNotes");
                    setOpenWithHeader(true);
                  }}
                >
                  <svg
                    width="19"
                    height="18"
                    viewBox="0 0 19 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.5 16.2C5.3105 16.2 1.9 12.969 1.9 9C1.9 5.031 5.3105 1.8 9.5 1.8C13.6895 1.8 17.1 5.031 17.1 9C17.1 12.969 13.6895 16.2 9.5 16.2ZM9.5 0C8.25244 0 7.0171 0.232792 5.86451 0.685084C4.71191 1.13738 3.66464 1.80031 2.78249 2.63604C1.00089 4.32387 0 6.61305 0 9C0 11.3869 1.00089 13.6761 2.78249 15.364C3.66464 16.1997 4.71191 16.8626 5.86451 17.3149C7.0171 17.7672 8.25244 18 9.5 18C12.0196 18 14.4359 17.0518 16.2175 15.364C17.9991 13.6761 19 11.3869 19 9C19 7.8181 18.7543 6.64778 18.2769 5.55585C17.7994 4.46392 17.0997 3.47177 16.2175 2.63604C15.3354 1.80031 14.2881 1.13738 13.1355 0.685084C11.9829 0.232792 10.7476 0 9.5 0ZM10.45 4.5H8.55V8.1H4.75V9.9H8.55V13.5H10.45V9.9H14.25V8.1H10.45V4.5Z"
                      fill="white"
                    />
                  </svg>
                  Add Notes
                </button>
              </div>
              <div
                className={
                  StateData?.note?.notes?.length > 3
                    ? "row notes-scroll-flexible"
                    : "row"
                }
              >
                {StateData?.note?.notes?.length > 0 ? (
                  StateData?.note?.notes?.map((activity: any, i: number) => (
                    <LeadNoteItems activity={activity} key={i} />
                  ))
                ) : (
                  <EmptyState type="notes" />
                )}
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="pills-Info"
              role="tabpanel"
              aria-labelledby="Info-tab"
            >
              <div className="d-flex justify-content-between align-items-center">
                {/* <h4 className=" mt-2">Lead Information</h4>
                <div>
                  <Button
                    size="small"
                    onClick={(e) =>
                      setDisableLeadInfo((prevState) => !prevState)
                    }
                  >
                    {disableLeadInfo ? (
                      <MdEdit title="Edit Changes" size={20} />
                    ) : (
                      <MdSave
                        onClick={() =>
                          (createLeadFormRef?.current as any)?.handleSubmit()
                        }
                        title="Save Changes"
                        size={20}
                      />
                    )}
                  </Button>
                </div> */}
              </div>
              {disableLeadInfo ? (
           <Information 
  leadToBeUpdate={_id}
  leadData={leadData}
/>
              ) : (
                <CreateLeadForm
                  isDetailsBox={true}
                  isEditMode={!disableLeadInfo}
                  disabled={disableLeadInfo}
                  showCreateNewLeadDrawer={() => {}}
                  getLeads={() => refreshData && refreshData()}
                  leadToBeUpdate={_id}
                  handleDrawerClick={() => {}}
                  selectedLeadId={leadListId || "0"}
                  leadList={StoreData.leadList.leadList}
                  ref={createLeadFormRef}
                  onClose={() => setDisableLeadInfo((prevState) => !prevState)}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <ConfirmationModal
        message="Are you sure you want to delete this task?"
        onConfirmation={handleDelete}
        showModal={showConfirmationModal}
        toggleModal={toggleConfirmationModal}
        title={action === "editTask" ? "Task" : "Activity"}
      />
      <ConfirmationModal
        message="Are you sure you want to delete this lead? This action cannot be undone."
        onConfirmation={handleDeleteLead}
        showModal={deleteModal}
        toggleModal={() => setDeleteModal(!deleteModal)}
        title="Delete Lead"
      />
      {/* Form Response Drawer */}
      <GlobalDrawer
        openWithHeader={viewFormResponse}
        setOpenWithHeader={() => {
          setViewFormResponse(false);
        }}
        drawerTitle="Form Response"
        size="lg"
      >
        {formData && (
          <FormResponse
            open={viewFormResponse}
            handleClose={() => {
              setViewFormResponse(false);
            }}
            formDetails={formData}
          />
        )}
      </GlobalDrawer>
      {/* Copy Lead */}
      <GlobalDrawer
        openWithHeader={copyLeadDrawer}
      
        setOpenWithHeader={() => {
          setCopyLeadDrawer(false);
        }}
        drawerTitle={activeLeadOption === "copy" ? "Copy Lead" : "Move Lead"}
        size="xs"
        customHeader
      >
        <label className="form-label">Select Destination lead list </label>
        <div>
          {leadListData?.length > 0
            ? leadListData?.map((item: any, ix: number) => {
                if (item._id != leadData.list) {
                  return (
                    <button
                      onClick={() => {
                        handleCopyLead(item._id);
                      }}
                      key={ix}
                      className="d-block bg-white w-100 p-3 rounded mb-2"
                      style={{ margin: "8px 0px", textAlign: "left" }}
                    >
                      {item.name}
                    </button>
                  );
                } else {
                }
              })
            : "No Record Found"}
        </div>
      </GlobalDrawer>

      {/* Assign Lead */}
    <AssignLeadDrawer
      isOpen={assignLeadDrawer}
      onClose={() => setAssignLeadDrawer(false)} 
      leadIds={[_id]} // Pass the current lead ID
      onAssignSuccess={(assignedToUser) => {
        // Update Redux store instead of making another API call
        const updatedLead = {
          ...leadData,
          assignedTo: assignedToUser
        };
        
        // Dispatch action to update the lead in Redux
        dispatch(updateSingleLead(updatedLead));
        
        // Also update local state if needed
        setLeadData(updatedLead);
        
        // Close the drawer
        setAssignLeadDrawer(false);
      }}
    />

  
      {isProductPickerOpen && (
  <MemoizedProductPickerPopup
    key={`product-picker-${selectedProducts
  .map(p => p?._id || 'missing')
  .join('-')}`}
    isOpen={isProductPickerOpen}
    onClose={handleClosePicker}
    onProductsSelect={handleProductsSelect}
    initialSelectedProducts={selectedProducts}
    
    excludeProductIds={[]}
    leadId={_id} // Pass the lead ID
    leadName={name} // Pass the lead name
    source="lead" 
  />
)}

{showBulkShareModal && (
  <BulkShareModal
    isOpen={showBulkShareModal}
    onClose={() => {
      setShowBulkShareModal(false);
      setContentData([]); // Clear data when closing
    }}
    selectedLeads={[leadData]} // Pass current lead as array
    contentTemplates={contentData} // Use local state, not Redux
  />
)}

{/* TODO: WhatsApp Conversations Feature - Component commented out for release */}
{/* 
<LeadCommunicationPopup 
  isOpen={showWhatsAppPopup}
  onClose={() => setShowWhatsAppPopup(false)}
  leadId={_id}
  leadName={name || "Unknown Lead"}
  leadPhone={leadData?.phone}
/>
*/}
    </div>
  );
};

export default LeadDetails;